import { CheckoutSessionCriteria, LoanCriteria, OrderCriteria, SinglePaymentCriteria } from '@nemuru-eng/js-api-client';
import { Link } from 'react-router-dom';

import { useCustomTheme } from '@/hooks/useCustomTheme';

export const toDealDetailFieldColumn = ({ flex, linkTo = () => '#' }: { flex?: number; linkTo: (id) => string }) => {
  const { palette, customBorderRadius } = useCustomTheme();
  return {
    flex: flex ?? 0.15,
    field: 'to_detail',
    sortable: false,
    headerName: ' ',
    disableOnRowClick: true,
    renderCell: (rowData: { row: OrderCriteria | LoanCriteria | CheckoutSessionCriteria | SinglePaymentCriteria }) => {
      return (
        <Link
          to={linkTo(rowData?.row.loanId || rowData?.row.id)}
          style={{
            minWidth: '40px',
            width: '100%',
            display: 'flex',
            justifyContent: 'center',
            paddingLeft: '0px',
            alignItems: 'center',
            height: '100%',
          }}
        >
          <div
            style={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              backgroundColor: palette.grey[100],
              width: 24,
              height: 24,
              borderRadius: customBorderRadius.button,
            }}
          >
            <i
              className="material-icons-outlined"
              style={{
                verticalAlign: 'sub',
                fontSize: '20px',
                color: palette.text.primary,
              }}
            >
              {'chevron_right'}
            </i>
          </div>
        </Link>
      );
    },
  };
};
